const getBackgroundColor = (colors, type) => {
    switch (type) {
        case 'success':
            return colors.status.success.gamma;
        case 'warn':
            return colors.status.warn.beta;
        case 'fail':
            return colors.status.fail.alpha;
        case 'brand':
            return colors.brand.primary.beta;
        case 'bold':
            return colors.brand.primary.alpha;
        case 'secondary':
            return colors.brand.secondary.gamma;
        default:
            // 'neutral'
            return colors.neutrals.background;
    }
};
export default getBackgroundColor;
//# sourceMappingURL=getBackgroundColor.js.map